import { render } from "./Hotel.vue?vue&type=template&id=19a0faa8&scoped=true"
import script from "./Hotel.vue?vue&type=script&lang=js"
export * from "./Hotel.vue?vue&type=script&lang=js"

import "./Hotel.vue?vue&type=style&index=0&id=19a0faa8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19a0faa8"

export default script